import { render, staticRenderFns } from "./BrazilMapAnalysis.vue?vue&type=template&id=b22e80c0&scoped=true"
import script from "./BrazilMapAnalysis.vue?vue&type=script&lang=js"
export * from "./BrazilMapAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BrazilMapAnalysis.vue?vue&type=style&index=0&id=b22e80c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e80c0",
  null
  
)

export default component.exports